import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import { updatePreferences } from '../Functions';
import Error from '../pages/Error';

export default class SurveyUnsub extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email : this.props.email,
      categories : this.props.categories,
      preferences : [],
      initialPrefs : {},
      prefUnion : {},
      updatedPrefs : {},
      loading : true,
      error : false,
      submitted : false,
    }
	}

  async componentDidMount() {
    this.setState({
      email : this.props.email,
      loading : false
    });
  }

  submitForm = async () => {
    let email = this.state.email;
    let prefs = { "SURVEYS": false };
    let channel = "EUNSUB";
    this.setState({ loading : true })
    await updatePreferences(email, channel, prefs).then(
      () => this.setState({ submitted : true })
    ).catch(
      (error) => this.setState({ error : true })
    ).finally(
      () => this.setState({ loading : false })
    );
  }

  resubscribe = async () => {
    let email = this.state.email;
    let prefs = { "SURVEYS" : true };
    let channel = "EUNSUB";
    this.setState({ loading : true })
    await updatePreferences(email, channel, prefs).then(
      () => this.setState({ submitted : false, loading : false})
    ).catch(
      (error) => this.setState({ error : true })
    ).finally(
      () => this.setState({ loading : false })
    );
  }

	render() {
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" id="spinner" size="sm">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      )
    }

    if (this.state.error) {
      return (
        <>
          <Error message="An error occurred loading this page, please try again later." />
        </>
      );
    }

    return (
      <>
        <h3>Communication Preferences for {this.state.email}</h3>

        <hr />
        {!this.state.submitted &&
          <p>
            You are currently subscribed for survey emails from Redwood Credit Union.
            Click the button below to unsubscribe from this email list.
          </p>
        }


        {!this.state.submitted && 
          <>
            <Button variant="danger" type="submit" onClick={ () => this.submitForm() } >
              Unsubscribe
            </Button>
          </>
        }
        
        {this.state.submitted && 
          <>
            <Button variant="success" type="submit" onClick={ () => this.resubscribe() } >
              Resubscribe
            </Button>
            <br /><br />
            <Alert variant='success'>You have been successfully removed from this subscriber list and won't receive any further emails from us.<br/><br/>
            If you've unsubscribed by accident, you can use the button above to resubscribe.
            </Alert>
          </>
        }
      </>
    );
	}
}